import * as React from 'react';
import { Flex } from '@latitude/box';
import { Link } from '@latitude/link';
import { formatTelNo } from '@latitude/tel';
import { BUTTON_STYLE } from '@latitude/core/utils/constants';

var HeroCallUs = function HeroCallUs(_ref) {
  var orCallUs = _ref.orCallUs;
  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Link, {
    button: BUTTON_STYLE.TERTIARY,
    href: "tel:" + formatTelNo(orCallUs),
    trackId: "hero-call-us-link"
  }, "Call us on ", orCallUs));
};

export default HeroCallUs;